import * as React from 'react';
import { navigate } from 'wouter/use-location';
import { logOut } from '../Services/UserService';

function Logout(): JSX.Element | null {
  logOut();
  navigate('/');
  return null;
}

export default Logout;
